import { render, staticRenderFns } from "./FinalProposalPage.vue?vue&type=template&id=7d5dfa33"
import script from "./FinalProposalPage.vue?vue&type=script&lang=js"
export * from "./FinalProposalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports